import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, HostListener, OnInit, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';
import { OrderUser, Item, Pix, Stripe, paymentForm } from 'src/app/shared/Interfaces/pedido';
import { ApiService } from 'src/app/shared/services/API/api.service';
import { CacheService } from 'src/app/shared/services/Cache/cache.service';
import { CartService } from 'src/app/shared/services/Cart/cart.service';
import { Company, ConnectionService } from 'src/app/shared/services/Connection/connection.service';
import { OrderService } from 'src/app/shared/services/Order/order.service';
import { UserService } from 'src/app/shared/services/User/user.service';
import { Location } from '@angular/common';
import { EventsService } from 'src/app/shared/services/events/events.service';
import { finalize, of, Subscription, switchMap, tap } from 'rxjs';
import { WebhookService } from 'src/app/shared/services/WeebHook/webhook.service';
import { Coupon } from 'src/app/shared/Interfaces/coupon';
import { Cliente } from 'src/app/shared/Interfaces/customer';
import * as _ from 'lodash';
import { paymentFormCompany, placeCounter, typeInterface } from 'src/app/shared/Interfaces/company';
import { LayoutComponent } from 'src/app/shared/layout/layout.component';
import { PedidoObject } from 'src/app/shared/models/pedido.class';
import { NotificationService } from 'src/app/shared/services/notification.service';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-order-confirmation-counter',
  templateUrl: './order-confirmation-counter.component.html',
  styleUrls: ['../order-confirmation/order-confirmation.component.css', "../../../assets/styles/global/_modal.scss"]
})
export class OrderConfirmationCounterComponent implements OnInit, AfterViewInit{
  //#region Variaveis Locais
    private webHookSubscription!: Subscription;
    public typeParam!: typeInterface;
    // public placeCounter!: placeCounter;
    // placeActive: boolean = false;
    openModal = false;
    showTopMenu = true;
    eventNavegation = false;
    openLoadingComponent = false;
    abilitButton = false;
    openModalPix = false;
    counterFinalizado = false;
    openCardLoading = false;
    openModalObservation = false;
    observationActive = false;
    hiddenCard: boolean = false;
    corretFormat!: boolean | undefined;
    toastCloseStoreActive = false;
    disableButton = false;
    openCouponView = false;
    desvinculationCoupon = false
    openModalFidelity = false;
    productsDiscount: Item[] = []
    couponSelected!: Coupon
    productPromotion: any;
    productInseringPromotion: any;
    modalPromotion = false;
    nameCompany: string = '';
    company!: Company;
    document: string = '';
    user!: Cliente;
    subTotal: number = 0;
    paymentObject: paymentForm[] = []
    flavorQuantity: number[] = []
    orderObservation: string = '';
    countText = 0;
    productsEmpty: Item[] = [];
    paymentFormEmpty!: paymentFormCompany;
    checkoutUrl: string = '';
    loadingCheckout: boolean = false;
    placeActive: boolean = false;

    //Objeto do pix
    pixObject: Pix = {
      createdAt: '',
      copyPaste: '',
      qrCode: '',
      id_order: '',
      value: 0,
    }

    //Objeto do pedido
    get sacola(): PedidoObject {
      return this.orderService.pedidoAtual;
    }

    //Sessão de observação
    observationSession = {
      checked: false,
      value: 0
    }
    
    //Objeto de metodo de recebimento
    methodReceiptSelected = {
      checked: true,
      value: 2
    };
  
    //Objeto de Tipo de pagamento
    typeMethodSelected = {
      checked: false,
      value: 0
    }
  
    //Objeto de Formas de pagamento
    paymentFormSelected = {
      checked: false,
      value: 0,
      form: this.paymentFormEmpty
    }

    //Objeto de forma de pagamento
    stripeObject: Stripe = {
      id_order: '',
      description: '',
      id_company: ''
    }


    placeCounter: placeCounter = {
      id_place: '',
      placeName: ''
    }

  //#endregion

  //#region Inicializadores

  constructor(
    private cacheService: CacheService,
    private router: Router,
    private notify: NotificationService,
    private orderService: OrderService,
    private cartService: CartService,
    private layout: LayoutComponent,
    private connection: ConnectionService,
    private eventsService: EventsService,
    private userService: UserService,
    private apiService: ApiService,
    private location: Location,
    private renderer: Renderer2,
    private elementRef: ElementRef,
    private webHookService: WebhookService,
    private ChangeDetectorRef: ChangeDetectorRef
    ){
      this.connection.nameCompany$.subscribe((newNameCompany) => {
        this.nameCompany = newNameCompany;
      })

      this.eventsService.eventNavegation$.subscribe((newEvent) =>{
        this.eventNavegation = newEvent
      })

      this.connection.company$.subscribe((newCompany) =>{
        this.company = newCompany
        if(this.company.configs.configObservation == 0)
        {
          this.hiddenCard = true;
          this.observationOrder({ checked: true, value: 0, name: '' })
        }
      })

      this.connection.user$.subscribe((User) =>{
        if(User){
          this.user = User;
          this.sacola.id_customerFK = this.user.id_customer;
        }
        else if(this.cacheService.getItemLocal('user_key')){
          this.connection.getUser(this.company.company.id_company);
        }
      })

      this.connection.typeParam$.subscribe((newTypeParam) => {
        this.typeParam = newTypeParam
      })

      this.orderService.placeCounter$.subscribe((newPlace) =>{
        if(newPlace.id_place != ''){
          this.placeCounter = newPlace;
          this.placeActive = true;
        }
      })

      this.layout.checkScreenSize();
  }

  //Iniciado assim que o component é criado
  ngOnInit(): void {
    this.location.replaceState(`${this.nameCompany}/B`);

    this.disablePullToRefresh();

    this.webHookSubscription = this.webHookService.getUpdates().subscribe(
      (content: any) => {
        if(content.type == 5){
          const data = content.data
          console.log(data);
          if(this.pixObject.id_order){
            if(data.id_order == this.pixObject.id_order)
              if(data.status == 1){
                clearInterval(this.pixObject.id_interval)
                this.notify.success('Pagamento confirmado com sucesso.')
                this.router.navigate([this.nameCompany, 'order-details', this.pixObject.id_order])
              }
              else if(data.status == 6){
                clearInterval(this.pixObject.id_interval)
                this.notify.error('Tempo de pagamento expirado.')
                this.router.navigate([this.nameCompany, 'pedidos'])
              }
          }

        }
      },
      (error) => {
        console.error('Erro ao receber mensagem do servidor WebHook:', error);
      }
    );
  }

  //Inicializado após o termino do carregamento DOM
  ngAfterViewInit(){
    this.montarPedido();
  }

  ngOnDestroy(): void {
    if(this.webHookSubscription) {
      this.webHookSubscription.unsubscribe();
    }
    clearInterval(this.pixObject.id_interval);
    this.sacola.fee = undefined;
    this.sacola.couponType = 0;
    this.sacola.coupons = false;
    this.sacola.discountValue = 0;
    this.sacola.orderType = 0;
  }

  //#endregion

  //#region Funções de estilo (Style)

    //Função responsavel por travar de o scroll para que a tela não seja recarregada no menu
    disablePullToRefresh() {
      const element = this.elementRef.nativeElement;
      let isAtTop = true;

      // Adiciona um ouvinte para o evento de scroll
      this.renderer.listen(window, 'scroll', () => {
        // Verifica se a página está no topo
        isAtTop = window.scrollY === 0;
      });

      this.renderer.listen(element, 'touchstart', (event) => {
        // Registra a posição inicial do toque
        const startY = event.touches[0].clientY;

        // Adiciona um ouvinte para o evento de movimento de toque
        const touchMoveListener = this.renderer.listen(element, 'touchmove', (moveEvent) => {
          // Calcula a diferença entre a posição inicial e a posição atual
          const deltaY = moveEvent.touches[0].clientY - startY;

          // Se a diferença for positiva (movimento para baixo) e a página estiver no topo, previne o comportamento padrão
          if (deltaY > 0 && isAtTop) {
            moveEvent.preventDefault();
          }
        });

        // Adiciona um ouvinte para o evento de término de toque
        const touchEndListener = this.renderer.listen(element, 'touchend', () => {
          // Remove os ouvintes após o término do toque
          touchMoveListener();
          touchEndListener();
        });
      });
    }

    @HostListener('window:resize', [])
    onWindowResize() {
      this.checkScreenSize();
    }

    //Verifica o tamanho da tela, esconde o Menu superior se necessario
    private checkScreenSize(){
      if(window.innerWidth <= 846){

        this.showTopMenu = false;
      }
      else{
        this.showTopMenu = true;
      }
    }

    //Função responsavel para não mostrar o modal caso tenha ido editar o usuario
    alterationEvent(){
      this.eventsService.eventNavegationSubject.next(true)
      this.userService.editingUserSubject.next(true);
      this.router.navigate([this.nameCompany, 'user-data'])
    }

    //O primeiro modal a ser aberto, quando o component inicia
    showModal(){
      setTimeout(() => {
        this.openModal = true
      }, 100);

    }

    //Função que é chamada para fazer a verificação se todos campos estão requeridos para abilitar o botão de finalizar o pedido
    habilitButton() {
      this.abilitButton = this.typeMethodSelected.checked && this.paymentFormSelected.checked;
    }

    viewCoupon(event: any){
      if(event == true){
        this.openCouponView = true;
      }
      else{
        this.openCouponView = false;
        setTimeout(() => {
          window.scrollTo({
            behavior: 'instant' as ScrollBehavior,
            top: document.documentElement.scrollHeight,
            left: 0,
          });
        }, 10);

      }
    }

    showModalObservation(){
      this.openModalObservation = true;
      this.orderObservation = this.sacola.orderObservation;
      this.countText = this.orderObservation.length;
    }

    confirmObservation(){
      this.openModalObservation = false
      this.sacola.orderObservation = this.orderObservation
      this.countText = this.orderObservation.length;
    }

    removeObservation(){
      this.orderObservation = '';
      this.sacola.orderObservation = '';
      this.countText = 0;
    }

    cancelObservation(){
      this.openModalObservation = false;
      this.orderObservation = this.sacola.orderObservation
      this.countText = this.orderObservation.length;
    }

    valueTextArea(event: any){
      const inputElement = event?.target as HTMLInputElement;

      if(inputElement.value.length <= 200){
        this.orderObservation = inputElement.value
        this.countText = this.orderObservation.length;
      }
      else{
        inputElement.value = this.orderObservation
      }

    }

    goback(): void{
      if(this.company.company.status == 1){
        this.router.navigate([this.nameCompany, 'carrinho']);
        this.eventsService.eventNavegationSubject.next(false)
      }
      else{
        this.router.navigate([this.nameCompany, 'B']);
        this.eventsService.eventNavegationSubject.next(false)
        this.eventsService.eventTypeReceiptSubject.next(0)
      }

    }

    documentValid(event: any){
      this.sacola.document_customer = event;
    }

  //#endregion

  //#region Funções de Lógica (Logic)

    //#region Seleção das informações

      //Card de observação de local no modo Balcão
      observationOrder(data: { checked: boolean, value: number, name: string }){

        if(this.handleDeselection(data, 'observation')) return;

        this.observationSession = data;

        this.sacola.localization = data.name;

        //Valida as propriedades do pedido para abilitar ou desabilitar o botão
        this.habilitButton();
        
      }

      //Card do tipo de pagamento - (Calcula R$)
      typePayment(data: { checked: boolean, value: number }){

        if(this.handleDeselection(data, 'type-payment')) return;

        //Carrega os tipos de pagamento
        this.typeMethodSelected = data;

        //Realiza o calculo total e descontos do pedido
        this.sacola.calcTotalOrder();

        //Valida as propriedades do pedido para abilitar ou desabilitar o botão
        this.habilitButton();
      }

      //Forma de pagamento do pedido - (Calcula R$)
      formPayment(data: { checked: boolean, value: number, form: paymentFormCompany}){

        if(this.handleDeselection(data, 'payment')) return;

        this.paymentFormSelected = data;

        //Valida se a forma de pagamento contem taxas ou descontos
        if(data.form.activeFee){
          this.addFees(data.form);
        }

        //Monta o objeto da forma de pagamento
        const form: paymentForm = {
          id_formpayment: data.form.id_paymentForm,
          changeFor: "0",
          onlinePay: 0,
          payStatus: 0,
          paymentName: this.paymentFormSelected.form.formName,
          paymentForm: this.paymentFormSelected.value,
          paymentValue: this.sacola.orderPrice.toString()
        }

        //Valida se o pagamento é pelo app ou na entrega | 0 = Pix Online | 9 = Stripe | 7 = Mercado Pago
        if(data.form.formNumber == 0 || data.form.formNumber == 9 || data.form.formNumber == 7){
          form.onlinePay = 1
          this.sacola.onlinePay = 1;
        }
        else{
          form.onlinePay = 0
          this.sacola.onlinePay = 0;
        }

        //adiciona ele no array e adiciona o array no pedido
        this.paymentObject.push(form)
        this.sacola.paymentForm = this.paymentObject

        //Valida a configuração de Borda pix na loja (Lógica Dibambina)
        if(this.company.configs.edgePix == 1){
          if(data.form.formNumber == 2 || data.form.formNumber == 0){
            this.promotionPayment(this.sacola)
          }
        }

        //Realiza o calculo total e descontos do pedido
        this.sacola.calcTotalOrder();

        //Valida as propriedades do pedido para abilitar ou desabilitar o botão
        this.habilitButton();
      }

      //Troco
      changeFor(event: any){
        //Valida e carrega a informação do troco no pedido
        if(typeof event == 'number')
        {
          this.sacola.changeFor = event.toString()
          this.sacola.paymentForm[0].changeFor = event.toString()
        }
      }

    //#endregion

    //#region Resets
      handleDeselection(data: { checked: boolean, value: number }, type: 'observation' | 'type-payment' | 'payment') {
        if (!data.checked && data.value === 0) {

          //Valida qual o tipo de 
          switch(type) {
            case 'observation':
              this.resetObservations();
              this.resetMethodPayment();
              this.resetPaymentForm();
            break;
            case 'type-payment':
              this.resetMethodPayment();
              this.resetPaymentForm();
              break;
            case 'payment':
              this.resetPaymentForm();
              break;
          }

          //Remove as taxas e borda pix
          this.removeFees();
          this.removeEdge();

          this.sacola.calcTotalOrder();

          this.habilitButton();

          return true; // sinaliza que foi tratado
        }

        this.sacola.calcTotalOrder();

        this.habilitButton();

        return false; // não houve deseleção
      }

      //Reseta o Tipo de pagamento
      resetObservations(){
        this.sacola.localization = ''
      }

      //Reseta o Tipo de pagamento
      resetMethodPayment(){
        this.typeMethodSelected = {checked: false, value: 0};
      }

      //Reseta a Forma de pagamento
      resetPaymentForm() {
        this.sacola.paymentForm = [];
        this.sacola.onlinePay = 0;
        this.sacola.changeFor = '';

        this.modalPromotion = false;
        this.paymentObject = [];
        this.paymentFormSelected = {checked: false, value: 0, form: this.paymentFormEmpty};
      }
    //#endregion

    //#region Taxas

      //Adiciona as taxas ao pedido
      addFees(form: paymentFormCompany){
        const fee = {
          id: form.id_paymentForm,
          value: false,
          percent: false,
          type: form.typeFee,
          fee: 0,
          valueFee: 0
        }

        if(form.value){
          fee.value = true
          fee.fee = form.fee
          fee.valueFee = form.fee
          this.sacola.fee = fee;
        }
        else{
          let valorTotal = this.sacola.subTotal;

          //Caso seja pedido com entrega
          if(this.sacola.orderType == 5){
            valorTotal += this.sacola.deliveryFee;
          }

          const percentValue = parseFloat(((valorTotal * form.fee) / 100).toFixed(2));
          fee.percent = true
          fee.fee = form.fee
          fee.valueFee = percentValue;
          this.sacola.fee = fee;
        }
      }

      //Remove as taxas
      removeFees(){
        if(this.sacola.fee){
          this.sacola.fee = undefined;
        }
      }

    //#endregion

    //#region Cashback

      //Adiciona o cashback ao pedido
      cashBack(data: { checked: boolean, value: number }){
        if(data.checked){
          this.sacola.cashbackUsed = data.value;
        }
        else{
          this.sacola.cashbackUsed = 0;
        }

        //Realiza o calculo total e descontos do pedido
        this.sacola.calcTotalOrder();
      }

    //#endregion 

    //#region Coupons

      //Quando o cupom selecionado é ativado - (Calcula R$)
      coupomSelected(event: any){

        if(event.check){
          let coupon: Coupon = event.coupon;

          if(coupon.couponType == 1 || coupon.couponType == 3){

            this.sacola.coupons = true;
            this.sacola.id_coupon = coupon.id_coupon;

            //Desconto Porcentagem
            if(coupon.percent != 0)
            {
              const discontFormated = coupon.percent / 100;
              let discont = this.sacola.subTotal * discontFormated;

              //Caso o desconto sejá em 100% do valor ele arredonda para 0.01
              if(discont == this.sacola.subTotal){
                discont = this.sacola.subTotal - 0.01;
              }

              this.sacola.discountValue = discont;
              this.sacola.couponType = 1;
            }
            //Desconto Valor
            else if(coupon.value != 0){
              let discont = coupon.value

              //Caso o desconto sejá maior que o valor do pedido ele arredonda para 0.01
              if(discont >= this.sacola.subTotal){
                discont = this.sacola.subTotal - 0.01;
              }

              this.sacola.discountValue = discont;
              this.sacola.couponType = 2;
            }
          }
          else if(coupon.couponType == 2){
            this.productsDiscount = this.sacola.products.filter(prodOrder => coupon.discountProducts.includes(prodOrder.id_product.toString())).map(prodOrder => ({ ...prodOrder }));
          
            if (this.productsDiscount.length === 1) {
              this.couponSelected = coupon
              this.applyCouponDiscount({ coupon, product: this.productsDiscount[0] });
              
            } else if (this.productsDiscount.length > 1) {

              if(coupon.percent != 0){
                this.openModalFidelity = true;
                this.couponSelected = coupon;
              }
              else{
                this.couponSelected = coupon
                this.applyCouponDiscount({ coupon, product: this.productsDiscount[0] });
              }

            } 
          }
        }
        else{
          this.deslectedCupom();
        }

        //Calcula o total do pedido ao aplicar ou retirar o cupom
        this.sacola.calcTotalOrder()
      }
  
      //Aplica o desconto de cupons do tipo produto 
      applyCouponDiscount(event: any) {
        const product = event.product;
        const coupon = event.coupon;
        const matchingItem = this.sacola.products.filter(productOrder => this.orderService.equalsObjectsCompare(product, productOrder, ["id_product", "observations"]));

        if(matchingItem){
          const discount = this.orderService.calculateDiscount(matchingItem[0], coupon);
          this.applyDiscountToProduct(matchingItem[0], discount);
  
          this.sacola.discountValue = discount;
          this.sacola.id_coupon = coupon.id_coupon;
          this.sacola.coupons = true;
          this.sacola.couponType = 2;
          this.notify.success('Cupom aplicado com sucesso.')
        }

        this.openModalFidelity = false;
      }
  
      //Aplica o disconto no produto
      private applyDiscountToProduct(matchingItem: any, discount: number) {
        if (matchingItem.quantity > 1) {
          //Novo Item
          const productDiscount = JSON.parse(JSON.stringify(matchingItem));
          productDiscount.totalPrice = matchingItem.totalPrice / matchingItem.quantity;
          productDiscount.oldPrice = productDiscount.totalPrice;
          productDiscount.discountValue = discount;
          productDiscount.totalPrice -= discount;
          productDiscount.discount = true;
          productDiscount.quantity = 1;

          if (productDiscount.flavorsValue) {
            productDiscount.flavorsValue = productDiscount.baseFlavorsValue;
          }   

          const priceDiscount = matchingItem.totalPrice / matchingItem.quantity;

          this.sacola.products.push(productDiscount);

          //Item Antigo
          if (matchingItem.flavorsValue) {
            matchingItem.flavorsValue -= matchingItem.baseFlavorsValue;
          }
          matchingItem.totalPrice = priceDiscount * (matchingItem.quantity - 1);
          matchingItem.quantity -= 1;
        } else {
          
          matchingItem.oldPrice = matchingItem.totalPrice;
          matchingItem.totalPrice -= discount;
          matchingItem.discount = true;
          matchingItem.discountValue = discount;

          if (matchingItem.flavorsValue) {
            matchingItem.flavorsValue -= matchingItem.baseFlavorsValue;
          }
        }

        let count = 0
        this.sacola.products.forEach((product, index) =>{
          count = 0
          product.categories.forEach(categorie =>{
            let value = 0
            categorie.additional.forEach(additional =>{
              value += additional.quantitySub
              if(categorie.flavorCategory == 1)
              {
                count += additional.quantitySub
              }
            })
          })
          this.flavorQuantity.push(count)
        })
      }
  
      //Quando o usuario cancela a seleção de produtos que ganharão o desconto
      cancelSelectCoupon(){
        this.desvinculationCoupon = true;
        this.openModalFidelity = false
        setTimeout(() => {
          this.desvinculationCoupon = false;
        }, 100);
      }
  
      //Desseleciona o cupom e retira suas propriedades no pedido
      deslectedCupom(){
  
        let coupon!: Coupon;
        this.couponSelected = coupon
  
        this.productsDiscount = []
  
        if(this.sacola.discountValue)
        {
          this.sacola.id_coupon = '0';
          this.sacola.coupons = false;
          this.sacola.discountValue = 0;
          this.sacola.couponType = 0;
        }

        this.sacola.products.forEach(product => {
          if(product.discount){
            product.discount = false,
            product.discountValue = 0,
            product.totalPrice = product.oldPrice
            product.oldPrice = 0
            this.orderService.joinDuplications(this.sacola.products)
          }
        });
      }

    //#endregion

    //#region Promoção para pagamento Pix (Borda Pix)

      //Detecta, se existe promoção para aqueles produtos
      promotionPayment(products: OrderUser){
        this.apiService.promotionPaymentForm(products).subscribe(
          (data) =>{
            if(!data.empty){
              this.productInseringPromotion = data.principalProducts;
              this.productPromotion = data.promoProducts[0];
              this.modalPromotion = true;
            }
          },
          (error) =>{
            console.log(error);
          }
        )
      }

      //Faz a lógica de localizar e adicionar a promoção no produto
      promotionSelected(data:{productOrder: Item, productPromotion: any}){   
        const product = this.sacola.products.filter(prod => this.orderService.equalsObjectsCompare(data.productOrder, prod, ["id_product", "observations", "discount"]))[0];

        if(product){
          if(product.quantity > 1){

            const newProduct = JSON.parse(JSON.stringify(product));
            newProduct.quantity = 1;
            newProduct.totalPrice = newProduct.baseValue;       
            if (newProduct.flavorsValue) {
              newProduct.flavorsValue = newProduct.baseFlavorsValue;
            }

            product.quantity = product.quantity - 1;
            product.totalPrice -= newProduct.baseValue;
            if (product.flavorsValue) {
              product.flavorsValue -= newProduct.baseFlavorsValue;
            }

            this.sacola.products.push(newProduct);
            data.productPromotion.promotionPay = true;
            newProduct.categories.push(data.productPromotion);

            let count = 0
            this.sacola.products.forEach((product, index) =>{
              count = 0
              product.categories.forEach(categorie =>{
                let value = 0
                categorie.additional.forEach(additional =>{
                  value += additional.quantitySub
                  if(categorie.flavorCategory == 1)
                  {
                    count += additional.quantitySub
                  }
                })
              })
              this.flavorQuantity.push(count)
            })

          }
          else{
            data.productPromotion.promotionPay = true;
            product.categories.push(data.productPromotion)
          }
          console.log('Borda adicionada',this.sacola.products);
          this.modalPromotion = false;
        }
        else{
          this.modalPromotion = false;
        }

      }

      //Remove a borda Pix gratis
      removeEdge(){
        this.sacola.products.forEach(products =>{
          const indexCat = products.categories.findIndex(categorie => categorie.promotionPay)
          if(indexCat != -1){
            products.categories.splice(indexCat, 1)
          }
        })
        this.orderService.joinDuplications(this.sacola.products);
      }

    //#endregion

    //#region Pix

      //Quando o usuario seleciona o pix, função responsavel de montalo
      paymentPix(sacola: OrderUser){
        this.openCardLoading = true;
        this.orderService.OrderUserPaymentOnline(sacola).subscribe(
          (data) =>{
            this.apiService.paymentPix(data).subscribe(
              (dataPayment) =>{
                this.openModalPix = true;
                this.openCardLoading = false;

                this.pixObject = {
                  id_order: data.id_order,
                  createdAt: data.createdAt,
                  copyPaste: dataPayment.qrcode,
                  qrCode: dataPayment.qrcode,
                  value: data.orderPrice,
                }
                
                console.log('PIX:',this.pixObject)

                this.startVerification(data.id_order, this.company.company.id_company);

                //Reseta o pedido e limpa o carrinho
                this.orderService.resetOrder();
                this.cartService.clearCart();
              },
              (error) =>{
                console.log(error)
                this.notify.error('Não foi possivel solicitar o pagamento.')
                this.openCardLoading = false;
              })
          },(error) =>{
            console.log(error);
            this.notify.error('Não foi possível concluir seu pedido.');
            this.openCardLoading = false;
          });
      }

      //Envia uma requisição para o servidor webhook para fazer a verificação
      startVerification(id_order: string, id_company: string){
        this.apiService.startVerification(id_order, id_company).subscribe(
          () =>{
            console.log('O Servidor iniciou a verificação')
            this.pixObject.id_interval = setInterval(() => {
              this.getStatusOrder(id_order)
            }, 10000) 
          },
          (error) =>{
            console.log(error);
          }
        )
      }

      //Resgata a confirmação de pagamento pix
      getStatusOrder(id_order: string){
        this.apiService.getStatusOrder(id_order).subscribe(
          (data) =>{
            if(data.status == 2){
              clearInterval(this.pixObject.id_interval)
              this.notify.success('Pagamento confirmado com sucesso.')
              // this.toastr.success('Pagamento Confirmado!', 'Sucesso', { positionClass: 'toast-top-right', timeOut: 4000});
              this.router.navigate([this.nameCompany, 'order-details', this.pixObject.id_order])
            }
            else if(data.status != 1){
              clearInterval(this.pixObject.id_interval);
              this.notify.error('Tempo de pagamento expirado.')
              // this.toastr.warning('Tempo de pagamento expirado!', 'Pix expirado', { positionClass: 'toast-top-right', timeOut: 4000});
              this.router.navigate([this.nameCompany, 'pedidos'])
            }
          },
          (error) =>{

          }
        )
      }

      //Fecha o contador quando o tempo termina
      finalizationCounter(event: any){
        this.counterFinalizado = event
      }

      //Volta para view de pedidos
      backOrders(){
        this.router.navigate([this.nameCompany, 'pedidos']);
      }

    //#endregion

    //#region Checkout (Stripe / Mercado Pago)

      //Realiza o pedido e gera o link e redireciona para o checkout (Stripe)
      paymentStripe(sacola: OrderUser) {
        this.loadingCheckout = true;
        this.orderService.OrderUserPaymentOnline(sacola).subscribe(
          (data) => {
            this.stripeObject.description = `Pedido #${data.displayId}#`;

            this.stripeObject.id_order = data.id_order,
            this.stripeObject.id_company = data.id_company

            this.apiService.postCreateCheckout(this.stripeObject.id_order, this.stripeObject.description, this.stripeObject.id_company).subscribe(
              (checkout) => {
                this.loadingCheckout = false;
                this.checkoutUrl = checkout.url
                window.location.href = this.checkoutUrl;
              },
              (errorCheckout) => {
                console.log(errorCheckout)
                this.loadingCheckout = false;
                this.notify.error('Não foi possivel solicitar o pagamento.')
                this.openCardLoading = false;
              }
            )
          },
          (error) => {
            console.log(error);
            this.notify.error('Não foi possível concluir seu pedido.');
            this.openCardLoading = false;
          }
        )

      }

      //Realiza o pedido e gera o link e redireciona para o checkout (Mercado Pago)
      paymentMercadoPago(sacola: OrderUser) {
        this.loadingCheckout = true;
        this.orderService.OrderUserPaymentOnline(sacola).subscribe(
          (data) => {
            const itens = this.sacola.products.map(product =>({
              title: product.name,
              unit_price: Number(product.unitPrice),
              quantity: product.quantity
            }))

            const body = {
              description: `Pedido #${data.displayId}#`,
              id_company: data.id_company,
              id_order: data.id_order,
              id_customer: this.user.id_customer,
              items: itens
            }

            this.apiService.postCallCheckoutMP(body).subscribe(
              (data) => {
                //Reseta o pedido e limpa o carrinho
                this.orderService.resetOrder();
                this.cartService.clearCart();

                //Fechar loading e navegar para pagina de checkout
                this.loadingCheckout = false;
                this.checkoutUrl = data.redirectUrl
                window.location.href = this.checkoutUrl;

              },
              (error) => {
                this.loadingCheckout = false;
                console.log(error)
                this.notify.error('Não foi possivel solicitar o pagamento.')
              }
            )
          },
          (error) => {
            this.notify.error('Não foi possível concluir seu pedido.');
            this.loadingCheckout = false;
            console.log(error)
          }
        )

      }

    //#endregion

    //#region Montagem e finalização do pedido

      //Monta o objeto de pedido de usuario, tanto para Pedido em balcão quanto em delivery
      montarPedido(){
        this.sacola.id_companyFK = this.company.company.id_company;
        this.sacola.orderType = 2;
        this.sacola.products = JSON.parse(JSON.stringify(this.orderService.bag));
        this.sacola.paymentForm = this.paymentObject;

        if(this.placeActive && this.sacola.placeName == ''){
          // this.notify.success(`Localização carregada: ${this.placeCounter.placeName}`)
          this.sacola.placeName = this.placeCounter.placeName;
        }
        else{
          // this.notify.error(`Erro ao carregar localização`)
        }

        this.sacola.calcTotalOrder();

        let count = 0;

        this.sacola.products.forEach((product, index) =>{
          count = 0
          product.categories.forEach(categorie =>{
            let value = 0
            categorie.additional.forEach(additional =>{
              value += additional.quantitySub
              if(categorie.flavorCategory == 1)
              {
                count += additional.quantitySub
              }
            })
          })
          this.flavorQuantity.push(count)
        })

        console.log(this.sacola);

        this.ChangeDetectorRef.detectChanges();
      }

      //Manda o pedido para o serviço e limpa os itens do carrinho
      // finalizationOrder(){
      //   this.disableButton = true;
      //   this.sacola.calcTotalOrder();
      //   console.log("Pedido Objeto:", this.sacola);

      //   if(this.sacola.placeName == '' && this.typeParam.numberParam){
      //     this.apiService.getPlacesCounter(this.typeParam.numberParam.toString()).subscribe(
      //     (data) =>{

      //       if(data.length > 0){
      //         if(data[0].deleted == 0 && data[0].active == 1){

      //           console.warn(`Localização:`, data[0].placeName);

      //           const place: placeCounter = {
      //             id_place: data[0].id_place,
      //             placeName: data[0].placeName
      //           }

      //           this.sacola.placeName = place.placeName;

      //           this.connection.updatePlace(place);

      //         }
      //       }

      //     },
      //     (error) =>{
      //       console.log(error);
      //     });
      //   }

      //   this.apiService.verifiStatusCompany(this.company.company.id_company).subscribe(
      //     (data) =>{
      //       if(data[0].open){
      //         this.eventsService.eventNavegationSubject.next(false)
      //         this.eventsService.eventTypeReceiptSubject.next(0)

      //         if(this.sacola.onlinePay == 1){
      //           if(this.sacola.paymentForm[0].paymentForm == 0){
      //             this.paymentPix(this.sacola);
      //           }
      //           else if(this.sacola.paymentForm[0].paymentForm == 9) {
      //             this.paymentStripe(this.sacola)
      //           }
      //           else if(this.sacola.paymentForm[0].paymentForm == 7){
      //             this.paymentMercadoPago(this.sacola);
      //           }

      //         }
      //         else{
      //           this.orderService.OrderUser(this.sacola);
      //           this.router.navigate([this.nameCompany, 'processing', 1]);
      //         }
        
      //         this.cartService.clearCart();
      //       }
      //       else{
      //         if(!this.toastCloseStoreActive)
      //           {
      //             this.toastCloseStoreActive = true;
      //             this.notify.error('Loja Fechada<br>Desculpe, mas a loja já fechou!')
      //           }
    
      //           this.connection.getCompany(this.nameCompany, this.typeParam.type).subscribe(
      //             (data) =>{
      //               console.log('Status da loja atualizado');
      //             },
      //             (error) =>{
      //               console.log('Erro inesperado', error)
      //             }
      //           )
      //       }
      //     },
      //     (error) =>{

      //     })
      // }

      // finalizationOrder() {
      //   this.disableButton = true;
      //   this.sacola.calcTotalOrder();

      //   const place$ = (this.sacola.placeName == '' && this.typeParam.numberParam)
      //     ? this.apiService.getPlacesCounter(this.typeParam.numberParam.toString())
      //     : of(null);

      //   place$.pipe(tap((data: any) => {
      //       if (data && data.length > 0 && data[0].deleted == 0 && data[0].active == 1) {

      //         const place: placeCounter = {
      //           id_place: data[0].id_place,
      //           placeName: data[0].placeName
      //         };

      //         this.sacola.placeName = place.placeName;
      //         this.connection.updatePlace(place);
      //       }
      //     }),
      //     switchMap(() =>
      //       this.apiService.verifiStatusCompany(this.company.company.id_company)
      //     ),
      //     finalize(() => this.disableButton = false)
      //   )
      //   .subscribe({
      //     next: (data) => {

      //       if (!data[0].open) {
      //         this.showClosedStore();
      //         return;
      //       }

      //       this.eventsService.eventNavegationSubject.next(false);
      //       this.eventsService.eventTypeReceiptSubject.next(0);

      //       if (this.sacola.onlinePay == 1) {
      //         this.handleOnlinePayment();
      //       } else {
      //         this.orderService.OrderUser(this.sacola);
      //         this.router.navigate([this.nameCompany, 'processing', 1]);
      //       }

      //       this.cartService.clearCart();
      //     },
      //     error: (err) => console.error(err)
      //   });
      // }

      async finalizationOrder() {

        try {

          this.disableButton = true;
          this.sacola.calcTotalOrder();

          /* ---------- PLACE ---------- */
          if (this.sacola.placeName == '') {

            const data: any = await firstValueFrom(
              this.apiService.getPlacesCounter(this.typeParam.qrCodeNumber.toString())
            );

            console.log(this.sacola)

            console.log(this.typeParam)

            if (data && data.length > 0 && data[0].deleted == 0 && data[0].active == 1) {

              const place: placeCounter = {
                id_place: data[0].id_place,
                placeName: data[0].placeName
              };

              this.orderService.updatePlace(place);
            }
          }

          /* ---------- STATUS COMPANY ---------- */
          const companyStatus: any = await firstValueFrom(
            this.apiService.verifiStatusCompany(this.company.company.id_company)
          );

          if (!companyStatus[0].open) {
            this.showClosedStore();
            return;
          }

          /* ---------- FLOW ---------- */
          this.eventsService.eventNavegationSubject.next(false);
          this.eventsService.eventTypeReceiptSubject.next(0);

          if (this.sacola.onlinePay == 1) {
            this.handleOnlinePayment();
          } else {
            this.orderService.OrderUser(this.sacola);
            this.router.navigate([this.nameCompany, 'processing', 1]);
          }

          this.cartService.clearCart();

        } catch (err) {
          console.error(err);
        }
        finally {
          this.disableButton = false;
        }
      }

      //Direciona para o tipo de pagamento online
      handleOnlinePayment() {
        const payment = this.sacola.paymentForm[0].paymentForm;

        switch (payment) {
          case 0:
            this.paymentPix(this.sacola);
            break;
          case 9:
            this.paymentStripe(this.sacola);
            break;
          case 7:
            this.paymentMercadoPago(this.sacola);
            break;
        }
      }

      //Mostra a mensagem de loja fechada
      showClosedStore() {
        if (!this.toastCloseStoreActive) {
          this.toastCloseStoreActive = true;
          this.notify.error('Loja Fechada<br>Desculpe, mas a loja já fechou!');
        }

        this.connection.getCompany(this.nameCompany, this.typeParam.type).subscribe();
      }

    //#endregion

  //#endregion

  copyPix(text: string) {
    const inputElement = document.createElement('input');
    inputElement.value = text;
    document.body.appendChild(inputElement);
    inputElement.select();
    document.execCommand('copy');
    document.body.removeChild(inputElement);
    this.notify.success('Código copiado com sucesso!');
  }

}
